import {Page, NavController, NavParams} from 'ionic-angular';
import { Http } from 'angular2/http';

@Page({
  templateUrl: 'build/pages/study-guide/study-guide.html'
})
export class StudyGuidePage {
  guide:Object;
  guide_info:{url: string};

  constructor(private nav:NavController, navParams:NavParams, public http: Http) {
    this.guide = {};
    this.guide_info = navParams.get('guide');
    this.http.get(this.guide_info.url)
        .subscribe(data => {
          // debugger;
          this.guide = data.json().acf;
        });
  }

  //itemTapped(event, item) {
  //  this.nav.push(ListPage, {
  //    item: item
  //  });
  //}
}